import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import List from './components/List'
import Create from './components/Create'

const KPIModule: RouteObject = {
    path: 'kpi-manage',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'create',
            element: <Create />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default KPIModule
